import React from 'react';
import { Flex } from 'antd';
import { Button, Empty } from '../../../common/web-view';
import styles from './index.module.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import { isCP } from '@utils/app-utils';
import { DASHBOARD_PATH } from '@constants/cp-paths';
import { OMS_DASHBOARD_PATH } from '@constants/seller-center-paths';
import { strings } from '@constants/strings';
import { sanitizePathname } from '@utils/utils';

const ErrorState = ({
  heading = strings.something_went_wrong,
  description = strings.temporary_issue_occurred,
  image,
  buttonText = 'Retry',
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = () => {
    const dashboardPath = isCP() ? DASHBOARD_PATH : OMS_DASHBOARD_PATH;
    if (sanitizePathname(location?.pathname) === dashboardPath) {
      window.location.reload();
    } else {
      window.location.pathname = dashboardPath;
    }
  };

  return (
    <Empty description={heading} image={image} rootClassName={styles.errorStateContainer}>
      <Flex vertical gap={12}>
        <p>{description}</p>
        <div>
          <Button
            type="primary"
            size="large"
            wide
            style={{
              '--ant-button-content-font-size-lg': '18px',
              '--btn-wide-width': '170px',
              height: 48,
            }}
            onClick={handleNavigate}
          >
            {buttonText}
          </Button>
        </div>
      </Flex>
    </Empty>
  );
};

export default ErrorState;
